<div class="popup-wrapper" [loadingSpinner]="{ isLoading, loadingHeight: 225 }">
    @if (project$ | async; as project) {
    <project-title [projectName]="project.ProjectName" [projectNumber]="project.ProjectNumber"></project-title>
    <div class="popup-body">
        <dl class="grid-12">
            <dt class="g-col-6">Duration</dt>
            <dd class="g-col-6">{{ project.Duration }}</dd>
            <dt class="g-col-6"><field-definition fieldDefinition="LeadImplementer"></field-definition></dt>
            <dd class="g-col-6">{{ project.LeadImplementerName }}</dd>
            <dt class="g-col-6"><field-definition fieldDefinition="EstimatedTotalCost"></field-definition></dt>
            <dd class="g-col-6">{{ project.EstimatedTotalCost | currency }}</dd>
            <dt class="g-col-6"><field-definition fieldDefinition="ThresholdCategory"></field-definition></dt>
            <dd class="g-col-6">{{ project.ThresholdCategories }}</dd>
            <dt class="g-col-6"><field-definition fieldDefinition="EIPFocusArea"></field-definition></dt>
            <dd class="g-col-6">{{ project.EIPFocusAreaName }}</dd>
            <dt class="g-col-6"><field-definition fieldDefinition="EIPProgram"></field-definition></dt>
            <dd class="g-col-6">{{ project.EIPProgramName }}</dd>
            <dt class="g-col-6"><field-definition fieldDefinition="EIPActionPriority"></field-definition></dt>
            <dd class="g-col-6">{{ project.EIPActionPriorityName }}</dd>
        </dl>
        <div>
            For project expenditures & results, see
            <a [areaLink]="['/projects', project.ProjectID]">Project Fact Sheet</a>
        </div>
    </div>
    }
</div>
